/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import moment from "moment";

interface ContasRecebidas {
  parceiro: string;
  cpf: string;
  numero: string | null;
  dataoperacao: string;
  conta: string;
  valor: number;
}

async function RelatorioRecebidas(dados: ContasRecebidas[], periodo: string) {

  const totalGeral = dados.reduce(
    (acc, item) => acc + (item?.valor ?? 0),
    0
  );

  const linhas: any[] = [];

  dados.forEach((r) => {

    linhas.push([
      {
        text: moment(r.dataoperacao).format("DD/MM/YYYY"),
        fontSize: 8
      },
      {
        text: r.numero ?? "",
        fontSize: 8
      },
      {
        text: r.parceiro + " - " + r.cpf,
        fontSize: 8
      },
      {
        text: r.conta,
        fontSize: 8
      },
      {
        text: formatMoney(r.valor),
        alignment: "right",
        bold: true,
        fontSize: 8
      }
    ]);

  });

  const documentDefinition: any = {

    pageSize: "A4",
    pageMargins: [25, 25, 25, 25],

    content: [

      {
        text: process.env.REACT_APP_URL_EMPRESA,
        fontSize: 14,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 4]
      },

      {
        text: "RELATÓRIO DE CONTAS RECEBIDAS",
        fontSize: 12,
        bold: true,
        alignment: "center"
      },

      {
        text: periodo,
        alignment: "center",
        fontSize: 9,
        margin: [0, 0, 0, 10]
      },

      {
        table: {
          headerRows: 1,
          widths: [60, 30, "*", 120, 60],

          body: [

            [
              { text: "Data", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Nº", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Cliente", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Conta", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Valor", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 8 }
            ],

            ...linhas

          ]
        },

        layout: {

          fillColor: function (rowIndex: number) {

            if (rowIndex === 0) return null;

            return rowIndex % 2 === 0 ? "#f9fafb" : null;

          },

          hLineColor: () => "#d1d5db",
          vLineWidth: () => 0

        }
      },

      {
        text: "TOTAL RECEBIDO: " + formatMoney(totalGeral),
        alignment: "right",
        bold: true,
        fontSize: 11,
        margin: [0, 15, 0, 0]
      }

    ]
  };

  pdfMake.createPdf(documentDefinition).open();
}

function formatMoney(value: number) {

  const v = Number(value ?? 0);

  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(v.toFixed(2)));

}

export default RelatorioRecebidas;